import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "styles/admin.css";
import ContentController from "./ContentController";
import AddUser from "./AddUser";
import MeetingControl from "./MeetingControl";
import CommentsControl from "./CommentsControl";
import DeveloperControl from "./DeveloperControl";

const controls = [
  { title: "Biz haqimizda", color: "#E9E9E9" },
  { title: "O'qituvchilar", color: "#CCF5CF" },
  { title: "Tadbirlar", color: "#E9CCF5" },
  { title: "Fikr-mulohazalar", color: "#CCEDF5" },
  { title: "Dasturchilar", color: "#F5CCCD" },
];

const MainPageControl = () => {
  const [selected, setSelected] = useState(null);

  return (
    <AnimatePresence mode="wait">
      {selected ? (
        <motion.div
          key="page"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -30 }}
          transition={{ duration: 0.4, type: "spring", stiffness: 120 }}
          style={{ width: "100%", height: "100%" }}
        >
          {selected === "Biz haqimizda" && (
            <ContentController goBack={() => setSelected(null)} />
          )}
          {selected === "O'qituvchilar" && (
            <AddUser goBack={() => setSelected(null)} />
          )}
          {selected === "Tadbirlar" && (
            <MeetingControl goBack={() => setSelected(null)} />
          )}
          {selected === "Fikr-mulohazalar" && (
            <CommentsControl goBack={() => setSelected(null)} />
          )}
          {selected === "Dasturchilar" && (
            <DeveloperControl goBack={() => setSelected(null)} />
          )}
        </motion.div>
      ) : (
        <motion.div
          key="menu"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="main-control"
        >
          <div className="card-wrapper">
            {controls.map((item, index) => (
              <motion.div
                key={index}
                className="card-item"
                onClick={() => setSelected(item.title)}
                initial={{ opacity: 0, y: 50, scale: 0.9 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                transition={{
                  delay: index * 0.1,
                  type: "spring",
                  stiffness: 200,
                  damping: 20,
                }}
                whileHover={{
                  scale: 1.05,
                  y: -8,
                  boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
                  transition: { duration: 0.3 },
                }}
                whileTap={{ scale: 0.98 }}
                style={{
                  backgroundColor: item.color,
                  cursor: "pointer",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <motion.div
                  className="card-shine"
                  initial={{ x: "-100%" }}
                  whileHover={{ x: "100%" }}
                  transition={{ duration: 0.6 }}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "50%",
                    height: "100%",
                    background:
                      "linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)",
                    pointerEvents: "none",
                  }}
                />

                <h3 style={{ position: "relative", zIndex: 2 }}>
                  {item.title}
                </h3>
              </motion.div>
            ))}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MainPageControl;
